import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RowsPerPageComponent } from './rows-per-page.component';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  imports: [
    CommonModule
    , MatSelectModule
  ]
  , declarations: [RowsPerPageComponent]
  , exports: [RowsPerPageComponent]
})
export class RowsPerPageModule { }
